import React from "react";
import { compareColor, compareIcon } from "utils/string";

interface ILast7DaysPercent {
  last7DaysPercent: number;
}
const Last7DaysPercent = (props: ILast7DaysPercent) => {
  const { last7DaysPercent } = props;
  const color = compareColor(last7DaysPercent);
  const TrendIcon = compareIcon(last7DaysPercent);
  return (
    <div className="flex items-center gap-1">
      <TrendIcon className="h-1.5 w-1.5" style={{ color }} />
      <span style={{ color }}>{last7DaysPercent}</span>
    </div>
  );
};

export default Last7DaysPercent;
